import { MapStyle } from '../interfaces/map-style.interface'

export const MAP_STYLES = {
  FIELDS: {
    color: '#ffd900',
  },
  CROPS: {
    color: '#f26716',
  },
  SELECTED_MARKER: {
    color: '#8672f1',
  },
  STENCIL: {
    color: '#fc00a8',
    opacity: 0.3,
  },
  DEFAULT_COLOR: {
    color: '#707070',
  },
} satisfies {
  [style: string]: MapStyle
}
